import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const HeaderCon = styled.h1`
  // these need to be !important because of a margin-bottom: 0; rule that 
  // applies to h1 elements somewhere else in the cascade that I cannot seem to find
  margin-bottom: ${({ theme }) => theme.spacing[2]} !important;
  line-height: 2.75rem;

  ${({ theme }) => theme.mq.md`
    margin-bottom: ${theme.spacing[1]} !important;
  `};

  ${({ theme }) => theme.mq.lg`
    line-height: 3.5rem;
  `};

  ${({ theme }) => theme.mq.xl`
    br {
      display: none !important;
    }
  `};
`;

export default function PageHeader({ children }) {
  return <HeaderCon>{children}</HeaderCon>;
}

PageHeader.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
    .isRequired,
};
